import { PolicyNotificationMetadataResponse } from '@lio/api-types';
import { config } from '@services/config';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const usePolicyMetadata = ({ policyId }: { policyId: string }) => {
  const client = useClient();

  const result = useQuery<PolicyNotificationMetadataResponse, Error>({
    queryKey: ['policyMetadata', { policyId }],
    queryFn: () => client.get(`policy/${policyId}/metadata`).json<PolicyNotificationMetadataResponse>(),
    ...config,
    staleTime: 0, // we intentionally want this to requery when you navigate back to the page
  });

  return { ...result, policyMetadata: result.data };
};
